import { useMemo } from "react";
import { getStageFeatures, StageFeatures } from "config/stageConfig";

export const useStageFeatures = (): StageFeatures => {
  return useMemo(() => getStageFeatures(), []);
};
